
export const FETCH_LANGUGE_REQUEST = "FETCH_LANGUGE_REQUEST";
export const FETCH_LANGUGE_SUCCESS = "FETCH_LANGUGE_SUCCESS";
export const FETCH_LANGUGE_FAIL = "FETCH_LANGUGE_FAIL";